import { useEffect, useState } from "react";

export const PAGE_SIZE = 10;

/**
 * One page of a list that was loaded in full (forms and their responses
 * are few, so they are paged here, not on the server). paged: more than a
 * page, so the pager shows.
 */
export function usePaged<T>(rows: T[] | undefined, size = PAGE_SIZE) {
  const [page, setPage] = useState(0);
  const total = rows?.length ?? 0;
  const pageCount = Math.max(1, Math.ceil(total / size));
  // A shorter list (a form deleted, say) keeps the page in range.
  useEffect(() => {
    if (page > pageCount - 1) setPage(pageCount - 1);
  }, [page, pageCount]);
  const current = Math.min(page, pageCount - 1);
  return {
    page: current,
    setPage,
    pageCount,
    paged: total > size,
    pageRows: (rows ?? []).slice(current * size, (current + 1) * size),
  };
}
